import React, { ReactElement, ReactNode } from 'react'

/**
 * recursively trys to find elements of specified type
 * and then injects the given element into their children
 * stops recursion after injection
 * @param children single or multiple children
 * @param inject element to be injected
 * @param types possible target types of elements
 * @returns children param (possible with injected elements)
 */
export const injectElement = (
  children: ReactNode,
  inject: ReactElement,
  types: string[]
): ReactNode => {
  if (React.Children.count(children) < 1) return children
  const injectedChildren = React.Children.map(children, (child) => {
    if (!React.isValidElement(child)) {
      return child
    }

    const element = child as ReactElement<{ children?: ReactNode }>
    if (element.props.children) {
      const props = {
        children: types.includes((child.type as any)?.name)
          ? [React.cloneElement(inject), ...React.Children.toArray(element.props.children)]
          : injectElement(element.props.children, inject, types),
      }
      child = React.cloneElement(child, props)
    }

    return child
  })
  return Array.isArray(children) ? injectedChildren : injectedChildren?.[0]
}
